import { ChapterArt } from '../components/ChapterArt';
import { PrimaryButton, SecondaryButton } from '../components/Buttons';

interface WelcomeScreenProps {
  onStart: () => void;
  onResume: () => void;
  hasProgress: boolean;
}

// Pantalla de bienvenida (handoff §11.1).
export function WelcomeScreen({ onStart, onResume, hasProgress }: WelcomeScreenProps) {
  return (
    <main className="gb-screen gb-screen--welcome">
      <div className="gb-welcome__art" aria-hidden="true">
        <ChapterArt kind="facade" eager />
      </div>
      <div className="gb-welcome__band">
        <p className="gb-welcome__eyebrow">Gimnasio Bilingüe Campestre Marie Curie</p>
        <h1 className="gb-welcome__title">Evaluación Institucional · Familias 2026</h1>
        <p className="gb-welcome__pact">
          Tu mirada define qué mejora el colegio este semestre. Esto toma entre 15 y 20 minutos y
          tus respuestas llegan directamente a los planes de mejoramiento y al Consejo Directivo.
        </p>
        <div className="gb-welcome__actions">
          {hasProgress ? (
            <PrimaryButton gold onClick={onResume}>
              Continuar con la evaluación
            </PrimaryButton>
          ) : (
            <PrimaryButton gold onClick={onStart}>
              Comenzar
            </PrimaryButton>
          )}
          {hasProgress ? <SecondaryButton onClick={onStart}>Empezar de nuevo</SecondaryButton> : null}
        </div>
        <details className="gb-welcome__legal">
          <summary>Confidencialidad y recomendaciones</summary>
          <p>
            El cuestionario es anónimo y los resultados se procesan únicamente de forma agregada. Si
            tienes varios hijos(as), te sugerimos completar un cuestionario por cada uno pensando en
            un hijo(a) específico(a). Si no tienes cómo darte cuenta de algo, marca «No estoy
            seguro(a)». Metodología alineada con la Guía 34 del MEN, el Decreto 1421 de 2017, las
            normas NTC ISO 9001 y 21001 y el sello EFR 3000-1.
          </p>
        </details>
      </div>
    </main>
  );
}
